/*LIBRARY*/
import { useState } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import LayerListRender from "./LayerListRender";
import EditFolder from "./EditFolder";
import DeleteFolder from "./DeleteFolder";
import EditIcon from "../common_icon/EditIcon";
import DeleteIcon from "../common_icon/DeleteIcon";
import Modal from "../common_modal/Modal";
import KERETA_API_INDONESIA_ICON from "../common_icon/KERETA_API_INDONESIA_ICON";

/*REDUX*/
import {
  setCloseFolder,
  setOpenAllFolder,
  setCloseAllFolder,
} from "../../App/actions/projectActions";
import {
  move_layers_into_any_folder,
  delete_layers_bulk,
} from "../../App/actions/layerNewActions";
import {
  set_value_properties,
  get_detail_many_layer,
  clear_layer_id,
} from "../../App/actions/propertiesActions";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const LayerListModeExpand = ({
  project,
  layer,
  auth,
  properties,
  setCloseFolder: setCloseFolderAction,
  setOpenAllFolder: setOpenAllFolderAction,
  setCloseAllFolder: setCloseAllFolderAction,
  move_layers_into_any_folder: moveLayers,
  delete_layers_bulk: deleteLayers,
  set_value_properties: setValueProperties,
  get_detail_many_layer: getDetailManyLayer,
  clear_layer_id: clearLayerId,
}) => {
  const [otherCloseStatus, setOtherCloseStatus] = useState(false);
  const [modalEditFolder, setModalEditFolder] = useState(false);
  const [modalDeleteFolder, setModalDeleteFolder] = useState(false);
  const [folder, setFolder] = useState({});
  const [name_filter, setNameFilter] = useState("");
  const [name_filter_final, setNameFilterFinal] = useState("");
  const [type_filter, setTypeFilter] = useState("");
  const [mode_filter, setModeFilter] = useState("name");
  const [is_mode_checklist_layer, setIsModeChecklistLayer] = useState(false);
  const [checkedLayers, setCheckedLayers] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [folderId, setFolderId] = useState("");
  const [message, setMessage] = useState("");
  const [confirmationText, setConfirmationText] = useState("");

  const on_resume_kai = (folderData) => {
    const { geo_layer_list } = layer;
    const { geo_project } = project;
    clearLayerId();
    setValueProperties({
      key: "sidebar_right_status",
      value: true,
    });
    setValueProperties({
      key: "folder_kai_timeseries",
      value: folderData,
    });
    if (folderData) {
      setValueProperties({
        key: "sidebar_right_status",
        value: true,
      });
      setValueProperties({
        key: "folder_kai_timeseries",
        value: folderData,
      });
      const layer_list = geo_layer_list
        .filter(
          (element) =>
            element?.folder === folderData?._id &&
            !element?.geo_layer?.geojson?.features?.length
        )
        .map((item) => item?.geo_layer?._id);
      if (layer_list.length > 0) {
        const params = {
          layer_list,
          geo_project_id: geo_project._id,
          folder_id: folderData._id,
        };
        getDetailManyLayer(params);
      }
    }
  };

  const resetCheckedListAndCancelMode = () => {
    setCheckedLayers([]);
    toggleIsModeChecklistLayer(false);
  };

  const toggleModalBulkMoveDelete = (content) => {
    setIsOpen(content ? true : false);
    setModalContent(content || "");
    setFolderId("");
    setMessage("");
    setConfirmationText("");
  };

  const setFolderBulkMoveDelete = (e) => {
    setFolderId(e.target.value);
  };

  const setConfirmationTextBulkMoveDelete = (e) => {
    setConfirmationText(e.target.value);
  };

  const handleSaveBulkMove = () => {
    // menunggu api
    const geo_project_id = project?.geo_project?._id || "";
    if (geo_project_id && checkedLayers.length > 0) {
      const body = {
        geo_project_id: geo_project_id,
        geo_folder_id: folderId,
        geo_layers: checkedLayers,
      };

      const res = moveLayers(body);
      if (res.status === 200) {
        toggleModalBulkMoveDelete();
      }
    }
  };

  const handleSaveBulkDelete = async (text, language) => {
    // menunggu api
    if (
      text ===
      `${auth?.user?.full_name} ${dict["is in charge of removing all of these layers"][language]}`
    ) {
      const geo_project_id = project?.geo_project?._id;
      let filtered_checked_layers = {
        geo_layer_attached_ids: [],
        geo_layer_ids: [],
        geo_project_id,
      };

      let { geo_layer_list } = layer;
      checkedLayers.forEach((layerId) => {
        const current_layer = geo_layer_list.find(
          (layerItem) => layerItem.geo_layer._id === layerId
        );
        if (current_layer?.status === "attached") {
          filtered_checked_layers["geo_layer_attached_ids"].push(layerId);
        } else {
          filtered_checked_layers["geo_layer_ids"].push(layerId);
        }
      });

      const res = await deleteLayers(filtered_checked_layers);
      if (res.status === 200) {
        toggleModalBulkMoveDelete();
      }
    } else {
      setMessage(dict["The sentence doesn't match"][language]);
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    if (name === "name_filter") {
      setNameFilter(value);
    } else if (name === "type_filter") {
      setTypeFilter(value);
    } else if (name === "mode_filter") {
      setModeFilter(value);
    }
  };

  const handleSetCheckedLayers = (value) => {
    setCheckedLayers(value);
    if (value.length === 0) {
      toggleIsModeChecklistLayer(false);
    }
  };

  const handleSelectLayersInThisFolder = (layers) => {
    let isCheckedAll = true;
    const layersId = layers.map((layerItem) => layerItem.geo_layer._id);
    for (const id of layersId) {
      if (!checkedLayers.includes(id)) {
        isCheckedAll = false;
        break;
      }
    }

    let new_layers = [];
    if (isCheckedAll) {
      new_layers = checkedLayers.filter((id) => !layersId.includes(id));
    } else {
      const filtered_layers = layersId.filter(
        (id) => !checkedLayers.includes(id)
      );
      new_layers = checkedLayers.concat(filtered_layers);
    }
    handleSetCheckedLayers(new_layers);
  };

  const toggleIsModeChecklistLayer = (value) => {
    setIsModeChecklistLayer(
      value !== undefined ? value : !is_mode_checklist_layer
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setNameFilterFinal(name_filter);
  };

  const setOpenAllFolderHandler = () => {
    setOpenAllFolderAction();
    const { geo_project } = project;
    const folders = geo_project?.folders || [];
    folders.forEach(({ _id, closeStatus }) => {
      const element = document.getElementById(_id);
      if (element) {
        element.style.height = closeStatus ? "33px" : "100%";
      }
    });
    setOtherCloseStatus(false);
    const otherFolderElement = document.getElementById("other_folder");
    if (otherFolderElement) {
      otherFolderElement.style.height = "100%";
    }
  };

  const setCloseAllFolderHandler = () => {
    setCloseAllFolderAction();
    const { geo_project } = project;
    const folders = geo_project?.folders || [];
    folders.forEach(({ _id, closeStatus }) => {
      const element = document.getElementById(_id);
      if (element) {
        element.style.height = closeStatus ? "33px" : "100%";
      }
    });
    setOtherCloseStatus(true);
    const otherFolderElement = document.getElementById("other_folder");
    if (otherFolderElement) {
      otherFolderElement.style.height = "25px";
    }
  };

  const toggle_edit_folder = (folderData) => {
    if (folderData) {
      setFolder(folderData);
    }
    setModalEditFolder(!modalEditFolder);
  };

  const toggle_delete_folder = (folderData) => {
    if (folderData) {
      setFolder(folderData);
    }
    setModalDeleteFolder(!modalDeleteFolder);
  };

  const onCloseFolder = (folder_id) => {
    setCloseFolderAction(folder_id);
    const { geo_project } = project;
    const folders = geo_project?.folders || [];
    folders.forEach(({ _id, closeStatus }) => {
      const element = document.getElementById(_id);
      if (element) {
        element.style.height = closeStatus ? "33px" : "100%";
      }
    });
  };

  const toggleCloseStatus = () => {
    setOtherCloseStatus(!otherCloseStatus);
    const otherFolderElement = document.getElementById("other_folder");
    if (otherFolderElement) {
      if (!otherCloseStatus) {
        otherFolderElement.style.height = "25px";
      } else {
        otherFolderElement.style.height = "100%";
      }
    }
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //global props
  let { loadingList, geo_layer_list, loadingProcess, itemLoading } = layer;
  const { geo_project, loadingDetail } = project;
  const { mode_map } = properties;

  // console.log("geo_layer_list.length=", geo_layer_list.length);

  //content
  const folders = geo_project?.folders || [];
  const folders_id = folders.map(({ _id }) => {
    return _id;
  });

  if (name_filter_final && mode_filter === "name") {
    geo_layer_list = geo_layer_list.filter(
      (l) =>
        l.geo_layer.name
          .toLowerCase()
          .includes(name_filter_final.toLowerCase()) ||
        l.geo_layer.description
          .toLowerCase()
          .includes(name_filter_final.toLowerCase())
    );
  }

  if (type_filter && mode_filter === "type") {
    const tipe_detail = {
      point: ["Position", "Point", "MultiPoint"],
      iot: ["IoT"],
      line: ["LineString", "MultiLineString"],
      polygon: ["Polygon", "MultiPolygon", "GeometryCollection"],
    };
    const tipe_array = tipe_detail[type_filter];
    geo_layer_list = geo_layer_list.filter((e) =>
      tipe_array.includes(e?.geo_layer?.type)
    );
  }

  const search_input = (
    <main
      style={{
        width: "100%",
        marginBottom: "5px",
      }}
    >
      <section>
        <form
          onSubmit={handleSubmit}
          style={{
            display: "flex",
            width: "100%",
            gap: "10px",
            alignItems: "flex-start",
          }}
        >
          {/* First column: mode_filter */}
          <div style={{ width: "40%" }}>
            <select
              name="mode_filter"
              id="mode_filter"
              onChange={handleChange}
              style={{
                width: "100%",
                fontSize: "13px",
              }}
            >
              <option value="name">{dict["Name"][language]}</option>
              <option value="type">{dict["Type"][language]}</option>
            </select>
          </div>

          {/* Second column: conditional filter input */}
          <div style={{ width: "60%" }}>
            {mode_filter === "name" ? (
              <input
                type="text"
                name="name_filter"
                id="name_filter"
                value={name_filter}
                onChange={handleChange}
                placeholder={dict["Filter layer by name"][language]}
                style={{
                  width: "100%",
                  fontSize: "13px",
                }}
              />
            ) : (
              <select
                name="type_filter"
                id="type_filter"
                onChange={handleChange}
                style={{
                  width: "100%",
                  fontSize: "13px",
                }}
              >
                <option value="">{dict["Select type"][language]}</option>
                <option value="point">{dict["Point"][language]}</option>
                <option value="iot">{dict["IoT"][language]}</option>
                <option value="line">{dict["Line"][language]}</option>
                <option value="polygon">{dict["Polygon"][language]}</option>
              </select>
            )}
          </div>
        </form>
      </section>

      {name_filter_final && (
        <section
          className="button_very_small"
          id="grey"
          style={{ marginBottom: "5px" }}
        >
          {mode_filter} : {name_filter_final}
        </section>
      )}
    </main>
  );

  const folder_expand_content = (
    <main className="folder_expand margin_bottom">
      <section
        onClick={setOpenAllFolderHandler}
        className="button background_black"
        id="outline_grey"
      >
        {dict["Open all folder"][language]}
      </section>
      <section
        onClick={setCloseAllFolderHandler}
        className="button background_black"
        id="outline_grey"
      >
        {dict["Close all folder"][language]}
      </section>
    </main>
  );

  let content =
    loadingList ||
    loadingDetail ||
    (loadingProcess && itemLoading === "get_list_by_link_project") ? (
      <div id="loading" style={{ height: "auto" }}></div>
    ) : (
      <main>
        {folder_expand_content}
        {search_input}
        <hr />
        {is_mode_checklist_layer && (
          <div className="center_perfect h_20 margin_10">
            <div className="three_container">
              <button
                className="button background_black"
                onClick={() => {
                  toggleModalBulkMoveDelete("move");
                }}
              >
                {dict["Move"][language]}
              </button>
              <button
                className="button background_red"
                onClick={() => {
                  toggleModalBulkMoveDelete("delete");
                }}
              >
                {dict["Delete"][language]}
              </button>
              <button
                className="button background_grey"
                onClick={() => {
                  resetCheckedListAndCancelMode();
                }}
              >
                {dict["Cancel"][language]}
              </button>
            </div>
          </div>
        )}
        <div
          id="layer_list_component"
          style={{
            height: "auto",
            marginTop: "5px",
          }}
        >
          {folders.map((folderItem, idx) => {
            const { name, _id, closeStatus } = folderItem;
            const geo_layer_list_render = geo_layer_list.filter(
              (geo_layer) => geo_layer.folder === _id
            );
            return (
              <main key={idx} className="folderBox" id={_id}>
                <main
                  className="folder_name text_collapse_4 noselect"
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    paddingTop: 4,
                  }}
                >
                  <section
                    id="expand_section"
                    onClick={() => onCloseFolder(_id)}
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fas"
                      data-icon="caret-down"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 320 512"
                      style={{
                        width: "1.25rem",
                        height: "1.25rem",
                        transition: "transform 0.5s ease 0s",
                        transform: `${
                          !closeStatus ? "rotate(-180deg)" : "rotate(0deg)"
                        }`,
                      }}
                    >
                      <path
                        fill="currentColor"
                        d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
                      ></path>
                    </svg>
                  </section>

                  <section
                    id="name_section"
                    onClick={() => onCloseFolder(_id)}
                    style={{
                      cursor: "pointer",
                      flex: 1,
                      display: "flex",
                      justifyContent: "flex-start",
                    }}
                  >
                    <div
                      style={{
                        display: "-webkit-box",
                        WebkitBoxOrient: "vertical",
                        WebkitLineClamp: 2,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "normal",
                      }}
                    >
                      {name}
                    </div>
                  </section>

                  {is_mode_checklist_layer && (
                    <section id="checklist_section" className="center_perfect">
                      <div
                        onClick={() => {
                          handleSelectLayersInThisFolder(geo_layer_list_render);
                        }}
                        className="pointer margin_5 padding_5 text_center bg_blue inline text_white rounded_5 hover_darkBlue"
                      >
                        {dict["All"][language]}
                      </div>
                    </section>
                  )}
                  {mode_map === "editor" && (
                    <section id="action_section">
                      {folderItem?.folder_type === "kai_timeseries" && (
                        <div
                          onClick={() => on_resume_kai(folderItem)}
                          style={{ display: "inline-block" }}
                          title="Resume timeseries"
                          className="margin_right"
                        >
                          <KERETA_API_INDONESIA_ICON />
                        </div>
                      )}
                      <div
                        onClick={() => toggle_edit_folder(folderItem)}
                        style={{ display: "inline-block" }}
                        title="Edit"
                      >
                        <EditIcon />
                      </div>
                      {[
                        "localhost:3003",
                        "dsdajakarta.mapid.io",
                        "dsdajakarta-alpha.mapid.io",
                        "dsdajakarta-beta.mapid.io",
                      ].includes(window.location.hostname) &&
                      !["dsdajakarta", "pusdatin_SDA"].includes(
                        auth.user?.name?.trim()
                      ) ? (
                        <></>
                      ) : (
                        <div
                          onClick={() => toggle_delete_folder(folderItem)}
                          style={{ display: "inline-block" }}
                          title="Delete"
                        >
                          <DeleteIcon />
                        </div>
                      )}
                    </section>
                  )}
                </main>
                <LayerListRender
                  checkedLayers={checkedLayers}
                  setCheckedLayers={handleSetCheckedLayers}
                  is_mode_checklist_layer={is_mode_checklist_layer}
                  toggleIsModeChecklistLayer={toggleIsModeChecklistLayer}
                  geo_layer_list={geo_layer_list_render}
                />
              </main>
            );
          })}
          <div className="folderBox" id="other_folder">
            <div
              className="text_collapse noselect folder_name"
              style={{ marginBottom: "15px", display: "flex" }}
            >
              {/* <div>{!otherCloseStatus ? "▼" : "► "}</div> */}
              <div onClick={toggleCloseStatus}>
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="caret-down"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 320 512"
                  style={{
                    width: "1.25rem",
                    height: "1.25rem",
                    transition: "transform 0.5s ease 0s",
                    transform: `${
                      !otherCloseStatus ? "rotate(-180deg)" : "rotate(0deg)"
                    }`,
                  }}
                >
                  <path
                    fill="currentColor"
                    d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
                  ></path>
                </svg>
              </div>
              <div
                className="w_full"
                style={{
                  display: "flex",
                  itemContent: "center",
                  justifyContent: "space-between",
                  paddingTop: "4px",
                }}
              >
                <section
                  onClick={toggleCloseStatus}
                  className="w_full center_perfect marginRight_20"
                >
                  {dict["Others"][language]}
                </section>
                {is_mode_checklist_layer && (
                  <section className="center_perfect">
                    <div
                      onClick={() => {
                        handleSelectLayersInThisFolder(
                          geo_layer_list.filter(
                            (geo_layer) =>
                              !folders_id.includes(geo_layer.folder)
                          )
                        );
                      }}
                      className="pointer margin_5 padding_5 text_center bg_blue inline text_white rounded_5 hover_darkBlue"
                    >
                      {dict["All"][language]}
                    </div>
                  </section>
                )}
              </div>
            </div>
            <LayerListRender
              checkedLayers={checkedLayers}
              setCheckedLayers={handleSetCheckedLayers}
              is_mode_checklist_layer={is_mode_checklist_layer}
              toggleIsModeChecklistLayer={toggleIsModeChecklistLayer}
              geo_layer_list={geo_layer_list.filter(
                (geo_layer) => !folders_id.includes(geo_layer.folder)
              )}
            />
          </div>
        </div>
      </main>
    );

  const modalEditFolderContent = modalEditFolder && (
    <Modal
      modalSize="medium"
      id="modal"
      isOpen={modalEditFolder}
      onClose={toggle_edit_folder}
    >
      <div className="box-body">
        <EditFolder folder={folder} toggle_edit_folder={toggle_edit_folder} />
      </div>
    </Modal>
  );

  const modalDeleteFolderContent = modalDeleteFolder && (
    <Modal
      modalSize="small"
      id="modal"
      isOpen={modalDeleteFolder}
      onClose={toggle_delete_folder}
    >
      <div className="box-body">
        <DeleteFolder
          folder={folder}
          toggle_delete_folder={toggle_delete_folder}
        />
      </div>
    </Modal>
  );

  const deleteLayersContent = (
    <div className="w_full">
      <div className="text_center font_20 marginBottom_20">
        {dict["Are you sure to delete?"][language]}
      </div>
      <div>
        <p className="text_center">{dict["Retype this sentence"][language]}</p>
        <p className="text_center">
          <strong>{`${auth?.user?.full_name} ${dict["is in charge of removing all of these layers"][language]}`}</strong>
        </p>
        {message && <div className="background_red text_white">{message}</div>}
        <input
          onChange={setConfirmationTextBulkMoveDelete}
          type="text"
          className="w_full"
        />
      </div>
      <div className="center_perfect">
        <button
          onClick={() => {
            handleSaveBulkDelete(confirmationText, language);
          }}
          className="button background_red"
        >
          {dict["Delete"][language]}
        </button>
      </div>
    </div>
  );

  const moveLayersContent = (
    <div className="w_full">
      <div className="text_center font_20 marginBottom_20">
        {dict["Move layers to a folder"][language]}
      </div>
      <div>
        <p className="text_center">{dict["Select a folder"][language]}</p>
        <select
          onChange={setFolderBulkMoveDelete}
          type="text"
          className="w_full"
        >
          <option value="">{dict["Outside folders"][language]}</option>
          {folders.map((folderItem) => (
            <option key={folderItem._id} value={folderItem._id}>
              {folderItem.name}
            </option>
          ))}
        </select>
      </div>
      <div className="center_perfect">
        <button
          onClick={() => {
            handleSaveBulkMove();
          }}
          className="button background_black"
        >
          {dict["Save"][language]}
        </button>
      </div>
    </div>
  );

  const modal_bulk_move_delete_content = isOpen && (
    <Modal
      modalSize="medium"
      id="modal"
      isOpen={isOpen}
      onClose={toggleModalBulkMoveDelete}
    >
      <div className="box-body">
        {modalContent === "move" ? (
          <div>{moveLayersContent}</div>
        ) : (
          <div>{deleteLayersContent}</div>
        )}
      </div>
    </Modal>
  );

  return (
    <div>
      {modalEditFolderContent}
      {modalDeleteFolderContent}
      {modal_bulk_move_delete_content}
      {content}
    </div>
  );
};

const mapStateToProps = (state) => ({
  project: state.project,
  layer: state.layer,
  auth: state.auth,
  properties: state.properties,
});

export default connect(mapStateToProps, {
  setCloseFolder,
  setOpenAllFolder,
  setCloseAllFolder,
  move_layers_into_any_folder,
  delete_layers_bulk,
  set_value_properties,
  get_detail_many_layer,
  clear_layer_id,
})(LayerListModeExpand);
